import { formatDate } from '@angular/common';

/**
 * India Standard Time as the fixed offset Angular's `formatDate` takes (it does not take an IANA zone such as
 * Asia/Kolkata).
 *
 * ⚠ EVERY DATE EITHER SITE PRINTS IS INDIA'S (review MR !1 N16). Memberships, redemptions, validity and requests are
 * recorded against India's calendar; printing them in the browser's own zone would show somebody abroad the day before
 * for anything stored at midnight. India keeps no daylight saving, so the fixed offset is exact all year.
 */
export const INDIA_TIME_OFFSET = '+0530';

/** The same offset in minutes, for code that works out India's day itself. */
export const INDIA_TIME_OFFSET_MINUTES = 330;

/** What a printed instant shows: the day, the day and the clock, or the clock alone. */
export type LmDateShape = 'date' | 'dateTime' | 'time';

/**
 * The ONE date format of both sites (owner, 2026-10-22, review MR !1 S16 / #4): `dd/MM/yyyy`, and `dd/MM/yyyy, hh:mm a`
 * where a time shows. Every clock is 12-hour - `HH:mm` is a defect wherever it appears.
 */
export const LM_DATE_PATTERNS: Readonly<Record<LmDateShape, string>> = {
    date: 'dd/MM/yyyy',
    dateTime: 'dd/MM/yyyy, hh:mm a',
    time: 'hh:mm a',
};

/**
 * Prints an instant in India's calendar and clock, in the one format. Empty for a missing or unparseable value - never a
 * raw ISO string on somebody's screen.
 *
 * The locale is fixed to `en-US` on purpose: the patterns are all digits plus AM/PM, and a locale change must not turn
 * "PM" into "pm" on one site only.
 */
export function formatLmDate(value: string | number | Date | null | undefined, shape: LmDateShape = 'date'): string {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return formatDate(date, LM_DATE_PATTERNS[shape], 'en-US', INDIA_TIME_OFFSET);
}
